import { useEffect, useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_PASSES } from "../../../api/apiRoutes";
import { AssortGroup } from "../../../models/AssortGroup";

export default function usePasses() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [passes, setPasses] = useState<AssortGroup[]>([]);

  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  const setDateBetween = async (date: Date) => {
    setSelectedDate(date);
  };

  const requestGetAssortGroups = async () => {
    const { result, isError } = await get(GET_PASSES(facilityIds));
    if (!isError) {
      setPasses(result);
    }
  };

  // useEffect(() => {
  //   if (facilityIds !== "" || facilityIds !== null) {
  //     const requestGetAssortGroups = async () => {
  //       const { result, isError } = await get(GET_PASSES(facilityIds));
  //       if (!isError) {
  //         setPasses(result);
  //         console.log(passes);
  //       }
  //     };
  //     requestGetAssortGroups();
  //   }
  // }, [facilityIds]);
  return {
    requestGetAssortGroups,
    passes,
    setDateBetween,
    selectedDate,
  };
}
